import { createGlobalState } from '~libs.ui.react';

import { MedicineId, MedicineSafetyIndicatorConfig, MedicineSafetyIndicatorType } from '../types';

export type MedicineSafetyIndicatorsConfigMapGlobalState = Map<
   MedicineId,
   Record<MedicineSafetyIndicatorType, MedicineSafetyIndicatorConfig>
>;

export const useMedicineSafetyIndicatorsConfigMapGlobalState = createGlobalState<MedicineSafetyIndicatorsConfigMapGlobalState>(
   new Map()
);
